module.exports = "<div class=\"inner-loader-container\">\r\n    <div class=\"inner-loader\"></div>\r\n</div>\r\n"